// Configuration centrale Noveocard — toute modification se fait ici.

export const SITE_NAME = "Noveocard";
// TODO: remplacer par le domaine final avant la mise en ligne (utilisé pour canonical, OG, sitemap).
export const SITE_URL = "https://noveocard.fr";

export const SLOGAN = "Un simple geste ouvre un monde";
export const MAIN_MESSAGE = "Votre identité. En version digitale.";
export const BASELINE =
  "Une carte digitale premium personnalisée qui connecte votre entreprise à votre univers digital.";

// WhatsApp — source unique de vérité pour tous les boutons du site.
export const WHATSAPP_DISPLAY = "+33 7 68 22 96 11";
export const WHATSAPP_INTL = "33768229611";
export const DEFAULT_WA_MESSAGE =
  "Bonjour Noveocard, je souhaite commander ma carte digitale personnalisée.";
export const waLink = (message = DEFAULT_WA_MESSAGE) =>
  `https://wa.me/${WHATSAPP_INTL}?text=${encodeURIComponent(message)}`;

export const RESPONSE_TIME = "Réponse sous 30 minutes";
export const DELIVERY_DELAY =
  "Production et livraison sous 7 à 10 jours ouvrés après validation de la commande.";
export const PRICE_TEASER = "Cartes NFC personnalisées à partir de 40 € TTC";

export const OFFERS = [
  {
    id: "standard",
    name: "Carte Standard",
    price: "40 € TTC",
    tagline: "L'essentiel, en un geste.",
    features: [
      "1 carte PVC personnalisée 86 × 54 mm",
      "Puce NFC intégrée",
      "1 lien digital au choix",
      "Logo, nom et couleurs de votre marque",
    ],
    message:
      "Bonjour Noveocard, je souhaite commander la Carte Standard (40 € TTC).",
  },
  {
    id: "multi",
    name: "Carte Multi-liens",
    price: "45 € TTC",
    tagline: "Tout votre univers, sur une carte.",
    highlight: true,
    features: [
      "1 carte PVC personnalisée 86 × 54 mm",
      "Puce NFC intégrée",
      "Page digitale regroupant plusieurs liens",
      "Instagram, Google Avis, WhatsApp, menu, site web…",
      "Contenu digital modifiable",
    ],
    message:
      "Bonjour Noveocard, je souhaite commander la Carte Multi-liens (45 € TTC).",
  },
  {
    id: "pack4",
    name: "Pack 4 cartes",
    price: "80 € TTC",
    tagline: "Pour équiper toute une équipe.",
    features: [
      "4 cartes PVC personnalisées 86 × 54 mm",
      "Puce NFC intégrée",
      "Personnalisation individuelle possible",
      "Idéal collaborateurs, serveurs, commerciaux",
    ],
    message:
      "Bonjour Noveocard, je souhaite commander le Pack 4 cartes (80 € TTC).",
  },
  {
    id: "sur-mesure",
    name: "Packs personnalisés",
    price: "Sur mesure",
    tagline: "Établissements, équipes, entreprises.",
    features: [
      "Volumes adaptés à vos besoins",
      "Collaborateurs, établissements, restaurants, entreprises",
      "Déclinaisons graphiques par équipe ou par lieu",
      "Accompagnement dédié sur WhatsApp",
    ],
    message:
      "Bonjour Noveocard, je souhaite un pack personnalisé de cartes pour mon équipe / mon établissement.",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/la-carte", label: "La carte" },
  { to: "/comment-ca-marche", label: "Comment ça marche" },
  { to: "/personnalisation", label: "Personnalisation" },
  { to: "/solutions", label: "Solutions" },
  { to: "/packs-personnalises", label: "Packs" },
  { to: "/conseils", label: "Conseils" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export const ACTIVITIES = [
  "Restaurant",
  "Café",
  "Bar",
  "Coiffeur",
  "Barbier",
  "Institut de beauté",
  "Boutique",
  "Garage",
  "Hôtel",
  "Immobilier",
  "Artisan",
  "Coach",
  "Entreprise",
  "Autre",
];
